export default __webpack_public_path__ + "static/media/hipercard-logo.8ae6104d.svg";